import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type {
  AgentBase,
  AgentCreatePayload,
  AgentUpdatePayload,
  AgentResetPasswordPayload,
  AgentItem,
  AgentItemListParams,
  AgentProspectsResult,
  AgentProspectsParams,
  AgentProspectVisitTask,
  AgentProspectVisitTaskListParams,
} from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/agent`;

export const getItemList = async (params?: AgentItemListParams): Promise<ApiResponse<AgentItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<AgentItem[]>>(`${BASE}/item-list`, { params });
  return data;
};

export const getList = async (params?: RequestParams): Promise<ApiResponseList<AgentBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<AgentBase>>(`${BASE}/index`, { params });
  return data;
};

export const getById = async (id: number): Promise<ApiResponse<AgentBase>> => {
  const { data } = await axiosInstance.get<ApiResponse<AgentBase>>(`${BASE}/show`, { params: { id } });
  return data;
};

export const create = async (payload: AgentCreatePayload): Promise<ApiResponse<AgentBase>> => {
  const { data } = await axiosInstance.post<ApiResponse<AgentBase>>(`${BASE}/create`, payload);
  return data;
};

export const update = async (payload: AgentUpdatePayload): Promise<ApiResponse<AgentBase>> => {
  const { data } = await axiosInstance.post<ApiResponse<AgentBase>>(`${BASE}/update`, payload);
  return data;
};

export const remove = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/delete`, { id });
  return data;
};

export const resetPassword = async (payload: AgentResetPasswordPayload): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/reset-password`, payload);
  return data;
};

export const getProspects = async (
  params: AgentProspectsParams
): Promise<ApiResponse<AgentProspectsResult>> => {
  const query: Record<string, unknown> = { id: params.id };
  if (params.date) query.date = params.date;
  const { data } = await axiosInstance.get<ApiResponse<AgentProspectsResult>>(`${BASE}/prospects`, {
    params: query,
  });
  return data;
};

export const getProspectVisitTasks = async (
  params: AgentProspectVisitTaskListParams
): Promise<ApiResponseList<AgentProspectVisitTask>> => {
  const { data } = await axiosInstance.get<ApiResponseList<AgentProspectVisitTask>>(
    `${BASE}/prospect-visit-tasks`,
    { params }
  );
  return data;
};
